// utils/stageInviteBus.ts
import SocketHandler from "./socketHandler";

type InviteMsg = {
  notification_type?: string;
  stage_card_booking_id?: number | string;
  user_id?: number | string;
  [k: string]: any;
};

const emitter = new EventTarget();

// keep a single live socket subscription per (bookingId:userId)
let wiredKey: string | null = null;

export function ensureInviteSocket(bookingId: string | number, userId: string | number) {
  const key = `${bookingId}:${userId}`;
  if (wiredKey === key) return;

  const socket = SocketHandler.getInstance();

  // drop previous wiring if any
  if (wiredKey) {
    const [b, u] = wiredKey.split(":");
    // your unsubscribe has only 2 args
    socket.unsubscribeToGuestInvitationReceived(b, u);
    wiredKey = null;
  }

  const handler = (msg: InviteMsg) => {
    if (Number(msg?.stage_card_booking_id) !== Number(bookingId)) return;
    if (String(msg?.user_id) !== String(userId)) return;
    const type = msg?.notification_type;
    if (!type) return;
    emitter.dispatchEvent(new CustomEvent(type, { detail: msg }));
  };

  socket.subscribeToGuestInvitationReceived(String(bookingId), String(userId), handler);
  wiredKey = key;
}

// listeners per type
export function onPerformerInvite(cb: (msg: InviteMsg) => void) {
  const fn = (e: Event) => cb((e as CustomEvent).detail);
  emitter.addEventListener("performer-invite", fn);
  return () => emitter.removeEventListener("performer-invite", fn);
}

export function onModeratorInvite(cb: (msg: InviteMsg) => void) {
  const fn = (e: Event) => cb((e as CustomEvent).detail);
  emitter.addEventListener("moderator-invite", fn);
  return () => emitter.removeEventListener("moderator-invite", fn);
}
